<template>
    <div>
        <e-dialog
                dialog-title="采购商查询"
                :center-dialog-visible="queryPurchaseCompanyVisible"
                popup-width="900px"
                :closeBtn="true"
                @resetPopupData="handleClose"
                @submitPopupData="handleConfirm"
        >
            <div class="company-box flex">
                <!--左侧树-->
                <div class="left-box">
                    <div class="title-box">采购商名称</div>
                    <div class="detail-box">
                        <el-input
                                class="margin-b10"
                                placeholder="输入关键字进行过滤"
                                v-model="leftTreeText"
                        >
                        </el-input>
                        <eui-btn
                                type="weak"
                                class="margin-b10"
                                size="20"
                                fontSize="10px"
                                :disabled="currentTree.length === 0"
                                @click="chooseCurrentTreeData"
                        >选中当前及以下节点
                        </eui-btn
                        >
                        <div class="data-box">
                            <el-tree
                                    :data="treeData"
                                    node-key="id"
                                    ref="tree"
                                    :check-strictly="true"
                                    :props="defaultProps"
                                    @check-change="handleCheckChange"
                                    show-checkbox
                                    :default-checked-keys="checkedKeys"
                                    :expand-on-click-node="false"
                                    :filter-node-method="filterNode"
                            >
                                <div slot-scope="{ node, data }" class="tree-box">
                                    {{ node.label }}
                                </div>
                            </el-tree>
                        </div>
                    </div>
                </div>
                <!-- 操作按钮-->
                <div class="btn-box">
                    <eui-btn @click="handleAdd" :disabled="selectData.length === 0">
                        添加
                        <eui-icon icon="eicon-arrow-right"></eui-icon>
                    </eui-btn>
                </div>
                <!--右侧选中数据-->
                <div class="right-box">
                    <div class="title-box">已选采购商名称</div>
                    <div class="detail-box">
                        <el-input placeholder="输入关键字进行过滤" v-model="rightText">
                        </el-input>
                        <eui-btn
                                type="weak"
                                class="margin-b10 margin-t10"
                                size="20"
                                fontSize="10px"
                                :disabled="rightSelectDataBase.length === 0"
                                @click="handleClearAll">清空所有
                        </eui-btn>
                    </div>
                    <div class="right-data-box margin-l10 margin-r10">
                        <div v-for="(item, index) in rightSelectData" :key="index">
                            <div class="flex-sb company-name-box">
                                <div>{{ item.companyName }}</div>
                                <div class="icon-box" @click="handleDel(index)">
                                    <eui-icon
                                            icon="eicon-r-l-guanbi"
                                            color="#333"
                                            font-size="16px"
                                    ></eui-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </e-dialog>
    </div>
</template>

<script>
import eDialog from '@/modules/projectA/components/common/e-dialog.vue';
import api from '@/modules/projectA/api/purchase';

export default {
  name: 'queryPurchaseCompanyDialog',
  components: {
    eDialog,
  },
  props: {
    queryPurchaseCompanyVisible: Boolean,
    purchaseCompanyInfo: Array
  },
  data() {
    return {
      groupCompany: [],
      userInfo: Object,
      leftTreeText: '',
      rightText: '',
      data: [],
      treeData: [],
      checkedKeys: [],//默认选中的数据
      rightSelectData: [], //右侧选中的数据
      rightSelectDataBase: [],//备份右侧选中的数据
      selectData: [], //左侧勾选的数据
      currentTree: [], //选中当前节点 下的数据
      currentId: '',//选中当前节点的id
      defaultProps: {
        label: 'companyName',
        children: 'children',
      },
    };
  },
  methods: {
    handleClearAll() {
      this.rightSelectDataBase = [];
      this.rightSelectData = [];
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.companyName.indexOf(value) !== -1;
    },
    chooseCurrentTreeData() {
      this.formatData(this.currentTree);
      this.$refs.tree.setCheckedKeys([this.currentId]);
    },
    //递归处理
    formatData(params) {
      let data = params;
      data.forEach(item => {
        if (item.hasOwnProperty("children") && item.children.length !== 0) {
          this.dealData(item);
          this.formatData(item.children);
        } else {
          this.dealData(item);
        }
      });
      return data;
    },
    //选中树以下节点 判断之前是否已选过
    dealData(item) {
      if (!this.checkedKeys.includes(item.id)) {
        this.checkedKeys.push(item.id);
        this.selectData.push(item);
        this.$refs.tree.setCheckedKeys([item.id]);
      }
    },

    handleDel(index) {
      this.rightSelectData.splice(index, 1);
      this.rightSelectDataBase.splice(index, 1);
    },
    handleAdd() {
      this.rightSelectData = JSON.parse(JSON.stringify(this.selectData));
      this.rightSelectDataBase = JSON.parse(JSON.stringify(this.selectData));

    },
    handleCheckChange(data, checked) {
      const indexNum = this.selectData.findIndex((item) => item.companyId === data.companyId);
      if (checked) {
        if (indexNum === -1) {
          this.selectData.push(data);
        }

        this.currentTree = data.children || [];
        this.currentId = data.id;
      } else {
        this.selectData.splice(indexNum, 1);
        const keyNum = this.checkedKeys.findIndex((item) => item === data.companyId);
        this.checkedKeys.splice(keyNum, 1);
        this.currentTree = [];
      }
    },
    handleConfirm() {
      this.$emit('confirmPurchaseCompany', this.rightSelectDataBase);
      this.handleClose();
    },
    handleClose() {
      this.$emit('update:queryPurchaseCompanyVisible', false);
    },
    //当前公司是否在集团中，是否是根节点，是否是根节点管理员，是否是管理员
    async groupJudge() {
      const res = await api.groupJudge();
      if (res.code === '200') {
        const {group, root, rootAdmin, admin} = res.data;
        if (!group) {
          this.dealCurrentCompany();
        } else {//是集团展示 当前及组织下属公司数据
          this.dealGroupCompany();
        }
      }
    },
    //当前及组织下属公司
    dealGroupCompany() {
      this.treeData = this.formatGroupData(this.data);
    },
    //递归处理寻找当前登录公司及其下属公司
    formatGroupData(params) {
      let data = params;
      data.forEach(item => {
        if (item.companyId === this.userInfo.companyId) {
          this.groupCompany = [item];
        }
        if (item.hasOwnProperty("children") && item.children.length !== 0 && this.groupCompany.length === 0) {
          this.formatGroupData(item.children);
        }
      });
      return this.groupCompany;
    },

    //获取左侧树
    async queryCurrentGroup() {
      const res = await api.queryCurrentGroup();
      if (res.code === '200') {
        if (res.data) {
          this.data = [res.data] || [];
        }
        this.groupJudge();
      }
    },
    //只展示当前公司
    dealCurrentCompany() {
      let params = [{
        id: '',
        companyId: this.userInfo.companyId,
        companyName: this.userInfo.companyName,
        parentId: 0
      }]
      this.treeData = params;
    },
    multiFilter(array, filters) {
      const filterKeys = Object.keys(filters);
      return array.filter((item) => {
        return filterKeys.every(key => {
          if (!filters[key].length) return true
          return !!~item[key].indexOf(filters[key])
        })
      })
    }
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('USERINFO'));
    this.queryCurrentGroup();
  },
  watch: {
    leftTreeText(val) {
      this.$refs.tree.filter(val);
    },
    rightText(val) {
      this.rightSelectData = this.multiFilter(this.rightSelectDataBase, {companyName: val});
    },
    purchaseCompanyInfo: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.rightSelectData = [...newVal];
        this.rightSelectDataBase = [...newVal];
        this.checkedKeys = newVal.map(item => item.id);
        this.selectData = [...newVal];
      }
    },
  },
};
</script>

<style scoped lang="scss">
.company-box {
    width: 100%;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;

    .company-name-box {
        width: 100%;
        height: 30px;
        line-height: 30px;
        padding: 0 10px;

        &:hover {
            background-color: #f5f7fa;
        }

        .icon-box {
            cursor: pointer;
        }
    }

    .left-box,
    .right-box {
        width: 400px;
        height: 400px;
        border: 1px solid #d9d9d9;

        .title-box {
            height: 30px;
            line-height: 30px;
            width: 100%;
            background-color: #f5f5f5;
            padding-left: 10px;
            border-bottom: 1px solid #d9d9d9;
        }

        .detail-box {
            padding: 10px;

            .data-box {
                max-height: 268px;
                overflow-y: auto;
            }
        }

        .right-data-box {
            max-height: 258px;
            overflow-y: auto;
        }
    }

    .btn-box {
        margin: 0 20px;
    }
}
</style>
